import { render } from "./NavOrganisationsSidebar.vue?vue&type=template&id=6e1f0293"
import script from "./NavOrganisationsSidebar.vue?vue&type=script&lang=js"
export * from "./NavOrganisationsSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__